import React, { useState } from 'react';
import { Marker, InfoWindow } from '@react-google-maps/api';

/** Handles rendering markers on the map. */
const Markers = ({ data }) => {
  const [activeMarker, setActiveMarker] = useState(null); // Track the active marker

  const handleMarkerClick = (markerId) => {
    setActiveMarker(markerId); // Set the clicked marker as active
  };

  const handleInfoWindowClose = () => {
    setActiveMarker(null); // Close the InfoWindow
  };

  return (
    <>
      {Object.keys(data).map((category) => {
        const categoryData = data[category];
        if (!categoryData || !Array.isArray(categoryData.items)) return null;

        return categoryData.items.flatMap((item, index) => {
          // If the item has a nested items array, iterate through it
          if (Array.isArray(item.items)) {
            return item.items.map((nestedItem, nestedIndex) => {
              if (
                !nestedItem.rough_location ||
                !nestedItem.rough_location.lat ||
                !nestedItem.rough_location.lng
              ) {
                return null; // Skip if rough_location is invalid
              }

              const markerId = `${category}-${index}-${nestedIndex}`;
              const imageUrl = `https://ai4curb.s3.us-west-2.amazonaws.com/complete_street/ObjImg/${nestedItem.img_full_path}`;

              return (
                <React.Fragment key={markerId}>
                  <Marker
                    position={{
                      lat: nestedItem.rough_location.lat,
                      lng: nestedItem.rough_location.lng,
                    }}
                    icon={{
                      url: categoryData.imageSrc, // Use category-specific icon
                      scaledSize: new window.google.maps.Size(30, 30), // Adjust marker size
                    }}
                    title={nestedItem.name || 'Unnamed Object'} // Tooltip for the marker
                    onClick={() => handleMarkerClick(markerId)} // Handle marker click
                  />
                  {activeMarker === markerId && (
                    <InfoWindow
                      position={{
                        lat: nestedItem.rough_location.lat + 0.0001, // Move InfoWindow above the marker
                        lng: nestedItem.rough_location.lng,
                      }}
                      onCloseClick={handleInfoWindowClose} // Close the InfoWindow
                    >
                      <div style={{
                        maxWidth: '300px',
                        padding: '10px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        fontFamily: 'Arial, sans-serif',
                      }}>
                        <img
                          src={imageUrl}
                          alt={nestedItem.name || 'Object Image'}
                          style={{
                            display: 'block', // Ensures the image behaves like a block element
                            margin: '0 auto', // Centers the image horizontally
                            height: '150px', // Fixed height for consistency
                            objectFit: 'cover', // Ensures the image fits within the height without distortion
                            borderRadius: '8px', // Adds rounded corners
                            marginBottom: '10px', // Adds spacing below the image
                          }}
                        />
                        <div style={{ marginBottom: '10px' }}>
                          <p style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            margin: '0 0 5px',
                            color: '#333',
                          }}>
                            <strong>Category:</strong> {category}
                          </p>
                          {/* <p>Image File Name: {imageUrl}</p> */}

                          <p style={{
                            fontSize: '14px',
                            margin: '0 0 5px',
                            color: '#555',
                          }}>
                            <strong>Object:</strong> {nestedItem.category
                              .split(' ')
                              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')}
                          </p>
                          <p style={{
                            fontSize: '14px',
                            margin: '0 0 5px',
                            color: '#555',
                          }}>
                            <strong>Geolocation:</strong> {nestedItem.rough_location.lat.toFixed(6)}, {nestedItem.rough_location.lng.toFixed(6)}
                          </p>
                          <p style={{
                            fontSize: '14px',
                            margin: '0',
                            color: '#555',
                          }}>
                            <strong>Last Updated:</strong> {new Date(nestedItem.last_updated_time).toLocaleDateString()}
                          </p>
                        </div>
                        <button
                          style={{
                            display: 'block',
                            width: '100%',
                            padding: '8px',
                            backgroundColor: '#007BFF',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                          onClick={() => alert('More details coming soon!')}
                        >
                          View Details
                        </button>
                      </div>
                    </InfoWindow>
                  )}
                </React.Fragment>
              );
            });
          }

          // If the item itself has a rough_location, render it as a marker
          // if (
          //   item.rough_location &&
          //   item.rough_location.lat &&
          //   item.rough_location.lng
          // ) {
          //   const markerId = `${category}-${index}`;
          //   const imageUrl = `https://ai4curb.s3.us-west-2.amazonaws.com/complete_street/ObjImg/${item.img_full_path}`;

          //   return (
          //     <React.Fragment key={markerId}>
          //       <Marker
          //         position={{
          //           lat: item.rough_location.lat,
          //           lng: item.rough_location.lng,
          //         }}
          //         icon={{
          //           url: categoryData.imageSrc, // Use category-specific icon
          //           scaledSize: new window.google.maps.Size(30, 30), // Adjust marker size
          //         }}
          //         title={item.name || 'Unnamed Object'} // Tooltip for the marker
          //         onClick={() => handleMarkerClick(markerId)} // Handle marker click
          //       />
          //       {activeMarker === markerId && (
          //         <InfoWindow
          //           position={{
          //             lat: item.rough_location.lat,
          //             lng: item.rough_location.lng,
          //           }}
          //           onCloseClick={handleInfoWindowClose} // Close the InfoWindow
          //         >
          //           <div style={{ maxWidth: '200px' }}>
          //             <img
          //               src={imageUrl}
          //               alt={item.name || 'Object Image'}
          //               style={{ width: '100%', height: 'auto', marginBottom: '10px' }}
          //             />
          //             <p>Placeholder text for the object description.</p>
          //           </div>
          //         </InfoWindow>
          //       )}
          //     </React.Fragment>
          //   );
          // }

          return null; // Skip if no valid rough_location
        });
      })}
    </>
  );
};

export default Markers;